// src/constants.js

export const COMPANY_NAME = 'Ash Towers';
export const HERO_TITLE = 'Crafting Digital Experiences for Tomorrow';
export const HERO_DESCRIPTION =
  'We are a software development company dedicated to building innovative and scalable solutions. Let us help you transform your ideas into reality.';
export const ABOUT_US_TITLE = 'About Us';
export const ABOUT_US_DESCRIPTION =
  'At Ashtowers, we are passionate about technology and its potential to drive progress. Our team of experienced developers, designers, and project managers work collaboratively to deliver high-quality software solutions tailored to your specific needs. We value innovation, quality, and client satisfaction.';
export const SERVICES_TITLE = 'Our Services';
export const MEMBERS_TITLE = 'Our Team';

export const SERVICES_DATA = [
  {
    title: 'Web Development',
    description:
      'We build responsive and user-friendly web applications using the latest technologies.',
    imageUrl: 'web.jpeg',
  },
  {
    title: 'Mobile App Development',
    description:
      'We create native and cross-platform mobile apps for iOS and Android.',
    imageUrl: 'mobile.jpeg',
  },
  {
    title: 'Cloud Solutions',
    description:
      'We help you leverage the power of the cloud to improve scalability and efficiency.',
    imageUrl: 'cloud.jpeg',
  },
  {
    title: 'UI/UX Design',
    description:
      'We design intuitive and engaging user interfaces that enhance the user experience.',
    imageUrl: 'ux-ui.jpeg',
  },
  {
    title: 'Software Consulting',
    description:
      'We provide expert advice and guidance to help you make informed technology decisions.',
    imageUrl: 'consulting.jpeg',
  },
  {
    title: 'AI Development',
    description:
      'We develop cutting-edge AI solutions to automate and optimize your business processes.',
    imageUrl: 'ai.jpeg',
  },
];

export const TEAM_MEMBERS = [
  {
    title: 'Lahiru Ranasinghe',
    description: 'Founder | Solutions Architect',
    imageUrl: 'lahiru.jpeg',
  },
  {
    title: 'Diego Torres',
    description: 'Founder | CTO',
    imageUrl: 'diego.jpeg',
  },
  {
    title: 'Nelson Penagos',
    description: 'Full Stack Developer',
    imageUrl: 'nelson.jpeg',
  },
  {
    title: 'Eduard Arias',
    description: 'Data Analitics',
    imageUrl: 'edu.jpeg',
  },
  {
    title: 'Tiana Vasiljev',
    description: 'Creative Direction | Branding & Marketing',
    imageUrl: 'tiana.jpeg',
  },
];

export const CLIENTS_LOGOS = [
  'kiindred.png',
  'fitideas.png',
  'TekSystems.png',
];

export const FOOTER_TEXT = `© ${new Date().getFullYear()} Ashtowers. All rights reserved.`;
export const CALL_TO_ACTION_TEXT = 'Get a Quote';
export const CALL_TO_ACTION_URL = 'https://www.ashtowers.com/contact';

export const CONTACT_US_TITLE = 'Contact Us';
export const CONTACT_US_EMAIL = 'diego.torres@ashtowers.com';
export const CONTACT_US_DESCRIPTION = `Ready to discuss your project? Get in touch with us today. ${CONTACT_US_EMAIL}`;

// Note: Telegram bot token and chat ID should ideally be stored in environment variables
// and handled on a backend for security. For this migration, we'll keep them here
// but acknowledge this is not best practice for production.
export const TELEGRAM_BOT_TOKEN = '7546204738:AAGbpMsvnPJd6EThJcK9URzYPZn95KrVVeA';
export const TELEGRAM_CHAT_ID = '847729120';

export const SECTION_IDS = {
  ABOUT: 'about',
  SERVICES: 'services',
  MEMBERS: 'members',
  CONTACT: 'contact',
  CLIENTS: 'clients',
};
